// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-primary { color: #2EB6C8; }\n.color-secondary { color: #777679; }\n.color-gray { color: #8F8F8F; }\n.color-outline { color: #D9D9D9; }\n.color-background { color: #F2F0F2; }\n.color-hc-error { color: #A3030A !important; }\n\n.color-bk-primary { background: #2EB6C8; }\n.color-bk-secondary { background: #777679; }\n.color-bk-gray { background: #8F8F8F; }\n.color-bk-outline { background: #D9D9D9; }\n.color-bk-background { background-color: #F2F0F2; }\n.color-bk-error { background: #A3030A !important; }\n", ""]);
// Exports
exports.locals = {
	"hc-navy": "#32445A",
	"hc-primary": "#2EB6C8",
	"hc-secondary": "#777679",
	"hc-gray": "#8F8F8F",
	"hc-outline": "#D9D9D9",
	"hc-background": "#F2F0F2",
	"hc-error": "#A3030A",
	"hc-orange": "#FF8E42"
};
module.exports = exports;
